const isGPIPolicy = (policyNumber) => {
  if (policyNumber) {
    return String(policyNumber).toUpperCase().includes('GPI');
  }

  return false;
};

export {
  isGPIPolicy,
};
